import { isNullOrUndefined } from 'util';
import { Converter } from '../converter.interface';
import { Injectable } from '@angular/core';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';
import { SingleCharacteristicObject } from 'src/app/models/characteristics/characteristic/single-characteristic-object.model';
import { MultiCharacteristicObject } from 'src/app/models/characteristics/characteristic/multi-characteristic-object.model';

@Injectable({
    providedIn: 'root'
})
export class CharacteristicConverter implements Converter<CharacteristicObject>{

    public convert(input: any): CharacteristicObject {

        if (isNullOrUndefined(input)) { this.throwError(); }

        if (Array.isArray(input.value)) {
            return new MultiCharacteristicObject(input.name, input.value, input.id);
        } else {
            return new SingleCharacteristicObject(input.name, input.value, input.id);
        }
    }

    throwError(): CharacteristicObject {
        throw new Error("Data input is mandatory to load a characteristic");
    }
}
